import {Action, Actions, Selector, State, StateContext, Store} from '@ngxs/store';
import {Injectable} from '@angular/core';
import {throwError} from 'rxjs';
import {ChecklistTemplateEntryDuplicationAction} from './checklist-template-entry-duplication.action';
import {ResetStateDefaults} from '../base-action-class.model';

interface ChecklistTemplateEntryDuplicationStateModel {
  duplicateEntries: { entryId: string, duplicateBlock: boolean };
  duplicateAllEntries: {checklistTemplateVersionId: string};
}

const getDefaults = (): ChecklistTemplateEntryDuplicationStateModel => ({
  duplicateEntries: {entryId: null, duplicateBlock: false},
  duplicateAllEntries: {checklistTemplateVersionId: null}
});

@State<ChecklistTemplateEntryDuplicationStateModel>({
  name: 'checklistTemplateEntryDuplication',
  defaults: getDefaults()
})
@Injectable()
export class ChecklistTemplateEntryDuplicationXsState {

  //region SELECTORS
  @Selector()
  static duplicateEntries(state: ChecklistTemplateEntryDuplicationStateModel): {entryId: string, duplicateBlock: boolean} {
    return state.duplicateEntries;
  }

  @Selector()
  static duplicateAllEntries(state: ChecklistTemplateEntryDuplicationStateModel): {checklistTemplateVersionId: string} {
    return state.duplicateAllEntries;
  }
  //endregion

  //region ACTIONS
  @Action(ChecklistTemplateEntryDuplicationAction.CopyDuplicateEntries)
  public copyDuplicateEntries(
    ctx: StateContext<ChecklistTemplateEntryDuplicationStateModel>,
    action: ChecklistTemplateEntryDuplicationAction.CopyDuplicateEntries
  ) {
    if (!action.entryId) {
      return throwError(() => new Error('Checklist template entry id is not set!'));
    }

    ctx.patchState({
      ...getDefaults(),
      duplicateEntries: {entryId: action.entryId, duplicateBlock: action.duplicateBlock}
    });
  }

  @Action(ChecklistTemplateEntryDuplicationAction.CopyDuplicateAllEntries)
  public copyDuplicateAllEntries(
    ctx: StateContext<ChecklistTemplateEntryDuplicationStateModel>,
    action: ChecklistTemplateEntryDuplicationAction.CopyDuplicateAllEntries
  ) {
    if (!action.checklistTemplateVersionId) {
      return throwError(() => new Error('Checklist template version id is not set!'));
    }

    ctx.patchState({
      ...getDefaults(),
      duplicateAllEntries: {checklistTemplateVersionId: action.checklistTemplateVersionId}
    });
  }

  @Action([
    ChecklistTemplateEntryDuplicationAction.ResetState,
    ResetStateDefaults
  ])
  public resetState(ctx: StateContext<ChecklistTemplateEntryDuplicationStateModel>): void {
    ctx.setState(getDefaults());
  }

  @Action(ChecklistTemplateEntryDuplicationAction.OpenCopyCompleteChecklistTemplate)
  public openCopyCompleteChecklistTemplate(
    ctx: StateContext<ChecklistTemplateEntryDuplicationStateModel>,
    action: ChecklistTemplateEntryDuplicationAction.OpenCopyCompleteChecklistTemplate
  ) {
    if (!action.checklistTemplateVersionId) {
      return throwError(() => new Error('Checklist template version id is not set!'));
    }

    ctx.patchState({
      ...getDefaults(),
      duplicateAllEntries: {checklistTemplateVersionId: action.checklistTemplateVersionId}
    });
  }
  //endregion

}
